import { render, staticRenderFns } from "./MediaSketeon.vue?vue&type=template&id=f63dbc4e&scoped=true"
import script from "./MediaSketeon.vue?vue&type=script&lang=js"
export * from "./MediaSketeon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63dbc4e",
  null
  
)

export default component.exports